"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function createEmbeddedApp(presentation, applicationVersion, metadata) {
    // build matches
    var parameterRegex = /(:([\w-\$]+))(.?$|[^\w-\$])/gm;
    var matches = [];
    var match = null;
    do {
        match = parameterRegex.exec(applicationVersion.embeddedUrlFormat || '');
        if (match) {
            matches.push(match);
        }
    } while (match !== null);
    // replace
    var url = applicationVersion.embeddedUrlFormat || '';
    var queryIndex = url.indexOf('?');
    matches.forEach(function (m) {
        var queryParamVariableName = m[1]; // Where the value of your input will be injected. E.g. ":location"
        var queryParamName = m[2]; // The query param name. E.g. "location"
        var _a = queryParamVariableName.split(':'), variableName = _a[1];
        var shouldEncodeValue = true;
        var value = '';
        if (variableName.charAt(0) === '$') {
            var variableIndex = url.indexOf(queryParamVariableName);
            var isPartOfQuery = queryIndex != -1 && variableIndex > queryIndex;
            var metadataKey = variableName.slice(1);
            if (metadataKey === 'renderMode') {
                value = metadata.renderMode;
            }
            else if (metadataKey === 'token') {
                value = presentation.token;
            }
            else if (metadataKey === 'deviceId') {
                if (metadata.deviceId) {
                    value = metadata.deviceId;
                }
                else {
                    // If :$deviceId is part of the URL path, avoid creating a broken URL if metadata.deviceId is not defined.
                    // This will use the variable name as the value instead of an empty string.
                    if (!isPartOfQuery) {
                        value = queryParamVariableName;
                    }
                }
            }
        }
        else {
            // Don't replace variables that are numbers to allow setting
            // port numbers in the embedded app url.
            if (!isNaN(Number(variableName)))
                return;
            var presentationProperty = applicationVersion.presentationProperties.find(function (p) { return p.name === variableName; });
            // If the presentation property is not found (this shouldn't happen), default to encoding the value.
            // Otherwise, only skip encoding if the presentation property's encode property is false.
            shouldEncodeValue =
                !presentationProperty || presentationProperty.encode !== false;
            value = presentation.applicationVariables[queryParamName];
            if (value === undefined)
                value = '';
            if (value === null)
                value = '';
            if (Array.isArray(value)) {
                value = JSON.stringify(value);
            }
            // Presentation property specific handling.
            if (presentationProperty) {
                // If the presentation property is a file, use the url property as the value.
                if (presentationProperty.type === 'file' && value && value.url) {
                    value = value.url;
                }
            }
        }
        if (shouldEncodeValue) {
            value = encodeURIComponent(value);
        }
        url = url.replace(queryParamVariableName, value);
    });
    return url;
}
exports.default = createEmbeddedApp;
